import PlayIcon from './svg/play-icon';
import PauseIcon from './svg/pause-icon';
import styles from './styles/audio-player.module.scss';
import type { MouseEventHandler } from 'react';

const PlayPauseButton = (props: {
	togglePlaying: MouseEventHandler<HTMLButtonElement>;
}) => {
	return (
		<button
			className={styles.play}
			aria-label="Play/Pause Toggle"
			onClick={props.togglePlaying}
		>
			{/* TODO: yikes is the accessible? what handles showing these, just the styles? */}
			<span className={styles.playIcon}>
				<PlayIcon />
			</span>
			<span className={styles.pauseIcon}>
				<PauseIcon />
			</span>
		</button>
	);
};

export default PlayPauseButton;
